<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard" v-show="selectMode===null">
            <div v-if="wtdata!==null">

              <div class="row" style="border-bottom:1px solid #CCC;padding-bottom:10px;">
                <div class="col-1 mt-2">
                  <button class="btn-transparent" @click="toggleTableFilters"><font-awesome-icon icon="filter" aria-label="Filter Entire Table"></font-awesome-icon>&nbsp;<span name="filter">Filters</span></button>
                </div>

                <div class="col-11" style="text-align:right;" v-show="showFilters===true">
                  <button class="btn-transparent" @click="clearTableFilters"
                          v-show="verified!==null||disabled!==null||privilegeselect!==null||filtergroup!==null||filterbundle!==null||filterproduct!==null||filtertp!==null">
                    <font-awesome-icon icon="times" style="color:darkred!important;" aria-label="Clear Filters"></font-awesome-icon>
                  </button>&nbsp;&nbsp;
                  <b-form-select id="ddlVerified" v-model="verified" :class="{'siselect':verified!==null}" :options="voptions" style="display:inline;width:13.5%;" @change="buildTable(false)"></b-form-select>&nbsp;&nbsp;
                  <b-form-select id="ddlDisabled" v-model="disabled" :class="{'siselect':disabled!==null}" :options="doptions" style="display:inline;width:13.5%;" @change="buildTable(false)"></b-form-select>&nbsp;&nbsp;
                  <b-form-select id="ddlPrivileges" v-model="privilegeselect" :class="{'siselect':privilegeselect!==null}" :options="privlevels" style="display:inline;width:13.5%;" @change="buildTable(false)"></b-form-select>&nbsp;&nbsp;
                  <b-form-select id="ddlGroups" v-model="filtergroup" :class="{'siselect':filtergroup!==null}" :options="groups" style="display:inline;width:13.5%;" @change="buildTable(false)"></b-form-select>&nbsp;&nbsp;
                  <b-form-select id="ddlBundles" v-model="filterbundle" :class="{'siselect':filterbundle!==null}" :options="bundles" style="display:inline;width:13.5%;" @change="buildTable(false)"></b-form-select>&nbsp;&nbsp;
                  <b-form-select id="ddlProducts" v-model="filterproduct" :class="{'siselect':filterproduct!==null}" :options="products" style="display:inline;width:13.5%;" @change="buildTable(false)"></b-form-select>&nbsp;&nbsp;
                  <b-form-select id="ddlTrainingPlans" v-model="filtertp" :class="{'siselect':filtertp!==null}" :options="tps" style="display:inline;width:13.5%;" @change="buildTable(false)"></b-form-select>

                </div>
              </div>

              <wondertable id="tblPoolMembers" :wtID="'poolMembers'" :tcapiData="wtdata" :methods="wtmethods" :noRecords="'This Pool Has No Members'" :defaultDirection="0" ref="wt"
                           :ids="wids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="'Pool Members'" :burgerMenu="burgermenu" :isAdmin="isAdmin"
                           :paginationCount="logcount" :totalRecords="totalrecords" :noFreeFilter="'true'"></wondertable>
            </div>
          </div>
          <div v-show="selectMode===0">
            <selectusers ref="selectUsersModule" :mode="'1'" :backbutton="true"></selectusers>
          </div>
          <div v-if="selectMode===1">
            <div class="mb-4 row">
              <div class="col-6">
                <h1>New Message</h1>
              </div>
              <div class="col-6 text-right">
                <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon>Go Back</a>
              </div>
            </div>
            <sendmessage ref="sMessage" :licensePoolID="poolID" :presetAddresses="selectedUsers" :allowForceEmail="true" :routeOnSend="rOnSend"></sendmessage>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div><acfooter></acfooter>


  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"
  import wondertable from "../../components/WonderTable.vue"
  import selectusers from "../../components/SelectUsers.vue"
  import sendmessage from "../../components/SendMessage.vue"
  //import * as mylib from '../../languageText.js';

  var PortalID = "";
  var portalURL = "";
  var UMichPoolID = "";
  if (window.location.origin.indexOf("admin.simmersion.com") > -1) {
    PortalID = "7728DEAD-2980-4748-9213-D49B97B74AE8";
    portalURL = "https://tcapi.simmersion.net";
    UMichPoolID = "E0CE9164-5DE4-487E-A5FA-32777755FA31";
  }
  else {
    PortalID = "7728DEAD-2980-4748-9213-D49B97B74AE8";
    portalURL = "https://tcapi.simmersionstage.net";
    UMichPoolID = "E0CE9164-5DE4-487E-A5FA-32777755FA31";
  }

  export default {
    name: 'PoolMembers',
    components: { acheader, acfooter, poolsidebar, wondertable, selectusers, sendmessage },
    data() {
      return {
        burgermenu: [],
        isAdmin: false,
        filterproduct: null,
        products: [],
        filterbundle: null,
        bundles: [],
        filtergroup: null,
        groups: [],
        filtertp: null,
        tps: [],
        privilegeselect: null,
        privlevels: [
          { value: null, html: "--- Privileges ---" },
          { value: "Trainee", html: "Trainee" },
          { value: "Pool Admin", html: "Pool Admin" },
          { value: "Group Admin", html: "Group Admin" },
          { value: "Pool Data Viewer", html: "Pool Data Viewer" },
          { value: "Group Data Viewer", html: "Group Data Viewer" }
        ],
        verified: null,
        disabled: null,
        voptions: [
          { value: null, html: "--- Verified ---" },
          { value: "true", html: "Is Verified" },
          { value: "false", html: "Not Verified" }
        ],
        doptions: [
          { value: null, html: "--- Disabled ---" },
          { value: "true", html: "Is Disabled" },
          { value: "false", html: "Not Disabled" }
        ],
        rOnSend: null,
        flow: null,
        logcount: null,
        totalrecords: null,
        poolID: null,
        selectMode: null,
        selectedUsers: [],
        showFilters: false,
        wids: ["ClientID"],
        wtdata: null,
        wtmethods: {
          addInvite: {
            method: function (param, ref) {
              ref.addInvite(param);
            },
            ref: this
          },
          assignBundles: {
            method: function (param, ref) {
              ref.doWTPage(0, false, ref.assignBundles, param);
            },
            ref: this
          },
          assignCurricula: {
            method: function (param, ref) {
              ref.doWTPage(0, false, ref.assignCurricula, param);
            },
            ref: this
          },
          assignGroups: {
            method: function (param, ref) {
              ref.doWTPage(0, false, ref.assignGroups, param);
            },
            ref: this
          },
          assignProducts: {
            method: function (param, ref) {
              ref.doWTPage(0, false, ref.assignProducts, param);
            },
            ref: this
          },
          disableMany: {
            method: function (param, ref) {
              ref.disableMany(param);
            },
            ref: this
          },
          enableMany: {
            method: function (param, ref) {
              ref.enableMany(param);
            },
            ref: this
          },
          removeInvite: {
            method: function (param, ref) {
              ref.removeInvite(param);
            },
            ref: this
          },
          resendVerification: {
            method: function (param, ref) {
              ref.resendVerification(param);
            },
            ref: this
          },
          sendMessageEmail: {
            method: function (param, ref) {
              ref.sendMessageEmail(param);
            },
            ref: this
          },
          RefreshData: {
            method: function (param, ref) {
              ref.RefreshData(param);
            },
            ref: this
          }
        }
      }
    },
    methods: {
      addInvite(param) {
        this.$router.push("/pool/" + this.$route.params.id + "/addinvite");
      },
      assignBundles(param) {
        this.flow = 1;
        this.$refs["selectUsersModule"].setData("Select Members to Assign Bundles", [], this.wtdata, null, null);
        this.selectMode = 0;
      },
      assignCurricula(param) {
        this.flow = 2;
        this.$refs["selectUsersModule"].setData("Select Members to Assign Training Plans", [], this.wtdata, null, null);
        this.selectMode = 0;
      },
      assignGroups(param) {
        this.flow = 3;
        this.$refs["selectUsersModule"].setData("Select Members to Assign Groups", [], this.wtdata, null, null);
        this.selectMode = 0;
      },
      assignProducts(param) {
        this.flow = 4;
        this.$refs["selectUsersModule"].setData("Select Members to Assign Products", [], this.wtdata, null, null);
        this.selectMode = 0;
      },
      buildTable(isfirst) {
        this.doCount(null).then(r => {
          if (r) {
            this.doWTPage(1, isfirst, null, null);
          }
        });
      },
      clearTableFilters() {
        this.verified = null;
        this.disabled = null;
        this.privilegeselect = null;
        this.filtergroup = null;
        this.filterbundle = null;
        this.filterproduct = null;
        this.filtertp = null;
        this.buildTable(false);
      },
      async doCount() {

        var fields = {
          LicensePoolID: this.$route.params.id
        };

        if (this.filterproduct !== null) {
          fields.ProductFilter = this.filterproduct;
        }

        if (this.filterbundle !== null) {
          fields.BundleFilter = this.filterbundle;
        }

        if (this.filtergroup !== null) {
          fields.GroupFilter = this.filtergroup;
        }

        if (this.filtertp !== null) {
          fields.TrainingPlanFilter = this.filtertp;
        }

        if (this.privilegeselect !== null) {
          fields.Privilege = this.privilegeselect;
        }

        if (this.verified !== null) {
          fields.IsVerified = this.verified;
        }

        if (this.disabled !== null) {
          fields.IsDisabled = this.disabled;
        }

        return this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetCombinedMembersCount",
            Fields: fields
          }
        ]).then(response => {
          try {
            var cr = JSON.parse(response.CommandResult);
            this.totalrecords = parseInt(cr.returnObjects[0].returnObject);

            if (this.totalrecords > 500) {
              var excess = this.totalrecords % 500;
              var pages = (this.totalrecords - excess) / 500
              if (excess > 0) {
                this.logcount = pages + 1;
              }
              else {
                this.logcount = pages;
              }
            }
            else {
              this.logcount = 1;
            }

            return true;
          }
          catch (e) {
            this.popDialog(1, "An unspecified error occurred");
          }

          return false;
        });
      },
      doWTPage(pg, isfirst, act, params) {

        var fields = {
          LicensePoolID: this.$route.params.id,
          Take: 500
        };

        if (pg > 0) {
          fields.Skip = (pg - 1) * 500;
        }

        if (this.filterproduct !== null) {
          fields.ProductFilter = this.filterproduct;
        }

        if (this.filterbundle !== null) {
          fields.BundleFilter = this.filterbundle;
        }

        if (this.filtergroup !== null) {
          fields.GroupFilter = this.filtergroup;
        }

        if (this.filtertp !== null) {
          fields.TrainingPlanFilter = this.filtertp;
        }

        if (this.privilegeselect !== null) {
          fields.Privilege = this.privilegeselect;
        }

        if (this.verified !== null) {
          fields.IsVerified = this.verified;
        }

        if (this.disabled !== null) {
          fields.IsDisabled = this.disabled;
        }

        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetCombinedMembers",
            Fields: fields
          }
        ]).then(response => {
          try {
            var cr = JSON.parse(response.CommandResult);
            var data = JSON.parse(cr.returnObjects[0].returnObject);           
            this.wtdata = data;
            if (!isfirst) {
              this.$refs["wt"].renderTable(data);
            }

            if (act !== null) {
              act(params);
            }

            Window.loadLanguageContent();

          }
          catch (e) {
            this.popDialog(1, "An unspecified error occurred");
          }
        });
      },

      goBack() {
        this.selectedUsers = [];
        this.selectMode = null;
      },
      removeInvite(cid) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to cancel the invite for this user?', {
          title: 'Confirm Cancel Invite',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "DeleteInviteConfirmation",
                Fields: {
                  LicensePoolID: this.sdata.activepool.LicensePoolID,
                  InviteConfirmID: cid
                }
              }
            ]).then(r => {
              this.popDialog(0, "Invite Removed");
              this.buildTable(false);
            });
          }
        });
      },
      resendInvite(cid) {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "ResendInviteConfirmation",
            Fields: {
              LicensePoolID: this.sdata.activepool.LicensePoolID,
              ClientID: cid
            }
          }
        ]).then(r => {
          this.popDialog(0, "Invite Resent");
        });
      },
      render(force) {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetProducts",
            Fields: {
              LicensePoolID: this.$route.params.id,
              LanguageID: sessionStorage.getItem("userLanguageID")
            }
          }, {
            Operation: "LicensePool",
            Function: "GetBundles",
            Fields: {
              LicensePoolID: this.$route.params.id
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetCurricula",
            Fields: {
              LicensePoolID: this.$route.params.id
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetGroups",
            Fields: {
              LicensePoolID: this.$route.params.id
            }
          }

        ]).then(response => {
          try {
            var cr = JSON.parse(response.CommandResult);

            for (var pr of JSON.parse(cr.returnObjects[0].returnObject)) {
              if (this.products.filter(p => p.value === pr.ProductID).length === 0) {
                this.products.unshift({
                  html: pr.ProductName,
                  value: pr.ProductID
                });
              }
            }
            for (var bd of JSON.parse(cr.returnObjects[1].returnObject)) {
              this.bundles.unshift({
                html: bd.BundleName,
                value: bd.BundleID
              });
            }
            for (var tp of JSON.parse(cr.returnObjects[2].returnObject)) {
              this.tps.unshift({
                html: tp.CurriculumName,
                value: tp.CurriculumID
              });
            }
            for (var grp of JSON.parse(cr.returnObjects[3].returnObject)) {
              this.groups.unshift({
                html: grp.LicensePoolGroupName,
                value: grp.LicensePoolGroupID
              });
            }

            var ddownsorter = function compare(a, b) {
              let comparison = 0;
              if (a.html > b.html) {
                comparison = 1;
              } else if (a.html < b.html) {
                comparison = -1;
              }
              return comparison;
            };

            this.products.sort(ddownsorter);
            this.groups.sort(ddownsorter);
            this.bundles.sort(ddownsorter);
            this.tps.sort(ddownsorter);

            this.products.unshift({
              value: this.emptyguid,
              html: "No Products"
            });
            this.bundles.unshift({
              value: this.emptyguid,
              html: "No Bundles"
            });
            this.tps.unshift({
              value: this.emptyguid,
              html: "No Training Plans"
            });
            this.groups.unshift({
              value: this.emptyguid,
              html: "No Groups"
            });


            this.products.unshift({
              value: null,
              html: "--- Products ---"
            });
            this.bundles.unshift({
              value: null,
              html: "--- Bundles ---"
            });
            this.tps.unshift({
              value: null,
              html: "--- Training Plans ---"
            });
            this.groups.unshift({
              value: null,
              html: "--- Groups ---"
            });

            this.buildTable(true);


          }
          catch (e) {
            this.popDialog(1, "An unspecified error occurred");
          }
        });
      },
      disableMany() {
        this.flow = 6;
        this.$refs["selectUsersModule"].setData("Select Members to Disable", [], this.wtdata.filter(p => p.IsDisabled.length === 0), null, null);
        this.selectMode = 0;
      },
      enableMany() {
        this.flow = 7;
        this.$refs["selectUsersModule"].setData("Select Members to Enable", [], this.wtdata.filter(p => p.IsDisabled.length > 0), null, null);
        this.selectMode = 0;
      },
      finishDisableMany() {
        var commands = [];

        for (var x = 0; x < this.selectedUsers.length; x++) {
          commands.push({
            Operation: "Client",
            Function: "ChangeActivationStatus",
            Fields: {
              ClientID: this.selectedUsers[x].ClientID,
              ActivationStatus: "true"
            }
          });
        }

        this.apiCommand(commands).then(r => {
          this.selectMode = null;
          this.popDialog(0, "Accounts disabled");
          this.buildTable(false);
        });
      },
      finishEnableMany() {
        var commands = [];

        for (var x = 0; x < this.selectedUsers.length; x++) {
          commands.push({
            Operation: "Client",
            Function: "ChangeActivationStatus",
            Fields: {
              ClientID: this.selectedUsers[x].ClientID,
              ActivationStatus: "false"
            }
          });
        }

        this.apiCommand(commands).then(r => {
          this.selectMode = null;
          this.popDialog(0, "Accounts enabled");
          this.buildTable(false);
        });
      },
      finishResendVerification() {
        var commands = [];

        for (var x = 0; x < this.selectedUsers.length; x++) {
          commands.push({
            Operation: "Client",
            Function: "SendVerificationEmail",
            Fields: {
              ClientID: this.selectedUsers[x].ClientID
            }
          });
        }

        this.apiCommand(commands).then(r => {
          this.selectMode = null;
          this.popDialog(0, "Verification emails resent");
          this.buildTable(false);
        });
      },
      resendVerification() {

        this.flow = 5;
        this.$refs["selectUsersModule"].setData("Select Members to Resend Verification", [], this.wtdata.filter(p => p.VerificationID !== "00000000-0000-0000-0000-000000000000"), null, null);
        this.selectMode = 0;

      },
      sendMessageEmail(param) {
        this.flow = 0;
        this.$refs["selectUsersModule"].setData("Select Members to Message/Email", [], this.wtdata, null, null);
        this.selectMode = 0;
      },
      RefreshData(param) {
        this.responseAvailable = false; 
        fetch(portalURL + "/SSO.svc/RunCronScript?poolid=91961F0A-B004-43A6-967D-32B36DDD66B0&clientid=" + this.udata.ClientID, {
          "method": "GET"
        })
          .then(response => {
            if (response.ok) {
              return response.json()
            } else {
              this.popDialog(1, "Server returned " + response.status + " : " + response.statusText);
            }
          })
          .then(response => {
            if (response.status == "started") {
              this.popDialog(0, "The process has started. You will receive an email when it is complete.");
            } else if (response.status == "running") {
              this.popDialog(2, "The process is already running. You will receive an email when it is complete.");
            } else if (response.status == "error") {
              this.popDialog(1, "Error occured while executing SSO User Refresh script.");
            }
            this.responseAvailable = true;
            this.doWTPage(0, false, null, null);
          })
          .catch(err => {
            this.popDialog(1, err);
          });
      },
      showAll(searchterm) {
        this.logcount = null;
        this.doWTPage(0, false, null, null);
      },
      toggleTableFilters() {
        if (this.showFilters) {
          this.clearTableFilters();
        }
        this.showFilters = !this.showFilters;
      },
      usersSelected() {

        this.selectedUsers = [];
        for (var i of this.$refs["selectUsersModule"].getData()) {
          if (this.selectedUsers.filter(p => p.ClientID === i.value).length === 0) {
            this.selectedUsers.push({
              Name: i.name,
              ClientID: i.value
            })
          }
        }

        if (this.flow === 0) {
          this.selectMode = 1;

        }
        if (this.flow > 0) {
          localStorage.setItem("assigndata", JSON.stringify(this.selectedUsers));
          if (this.flow === 1) {
            this.$router.push("/pool/" + this.$route.params.id + "/assign/bundles/do");
          }
          if (this.flow === 2) {
            this.$router.push("/pool/" + this.$route.params.id + "/assign/trainingplans/do");
          }
          if (this.flow === 3) {
            this.$router.push("/pool/" + this.$route.params.id + "/assign/groups/do");
          }
          if (this.flow === 4) {
            this.$router.push("/pool/" + this.$route.params.id + "/assign/products/do");
          }
          if (this.flow === 5) {
            this.finishResendVerification();
          }
          if (this.flow === 6) {
            this.finishDisableMany();
          }
          if (this.flow === 7) {
            this.finishEnableMany();
          }
        }
      }

    },
    mounted() {
      this.doPage().then(r => {
        this.bootstrapPool(this.$route.params.id);
        this.isAdmin = this.sdata.activepool.IsAdmin;

        var self = this;
        window.removeInvite = function (cid) {
          self.removeInvite(cid);
        }
        window.resendInvite = function (cid) {
          self.resendInvite(cid);
        }


        if (this.$route.params.id == '91961f0a-b004-43a6-967d-32b36ddd66b0') {
          this.burgermenu = [
            [
              { html: "Add/Invite", value: "addInvite" }
            ],
            [
              { html: "Send Message", value: "sendMessageEmail" }
            ],
            [
              { html: "Select Action", value: null },
              { html: "Assign Bundles", value: "assignBundles" },
              { html: "Assign Training Plans", value: "assignCurricula" },
              { html: "Assign Groups", value: "assignGroups" },
              { html: "Assign Products", value: "assignProducts" },
              { html: "Mass Disable Accounts", value: "disableMany" },
              { html: "Mass Enable Accounts", value: "enableMany" },
              { html: "Resend Verification Emails&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", value: "resendVerification" }
            ]
            ,
            [
              { html: "Refresh User List", value: "RefreshData" }
            ]
          ];

          if (sessionStorage.getItem("isSimmersionUser")) {
            this.burgermenu.splice(0, 3);
          }

        }
        else {
          this.burgermenu = [
            [
              { html: "Add/Invite", value: "addInvite" }
            ],
            [
              { html: "Send Message", value: "sendMessageEmail" }
            ],
            [
              { html: "Select Action", value: null },
              { html: "Assign Bundles", value: "assignBundles" },
              { html: "Assign Training Plans", value: "assignCurricula" },
              { html: "Assign Groups", value: "assignGroups" },
              { html: "Assign Products", value: "assignProducts" },
              { html: "Mass Disable Accounts", value: "disableMany" },
              { html: "Mass Enable Accounts", value: "enableMany" },
              { html: "Resend Verification Emails&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", value: "resendVerification" }
            ]
          ];

          if (sessionStorage.getItem("isSimmersionUser")) {
            this.burgermenu.splice(0, 1);
            this.burgermenu.splice(1, 1);
          }

        }




        this.poolID = this.$route.params.id;
        this.rOnSend = "/pool/" + this.$route.params.id + "/members";

        this.render(false);
      });
      if (sessionStorage.getItem("isSimmersionUser")) {
        this.popDialog(2, "Account management is handled at the organization level. To make account related changes, please log into the Lifeline Learning Portal and visit the Users page.");
      }


    }
  }
</script>
